import React, { useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

import Header from "../components/header";
import Footer from "../components/footer";

import { Setting, Home, Card, Truck, Secure } from "../common/svg";

import bg_top from "../../static/images/gps/bg_top.png";
import bg_bottom from "../../static/images/gps/bg_bottom.png";
import bg_content from "../../static/images/gps/bg-content-banner.png";
import gps_wired from "../../static/images/gps/gpsWired.png";
import gps_wireless from "../../static/images/gps/gpsWireless.png";
import gps_wired_feature1 from "../../static/images/gps/gpsWired_feature1.svg";
import gps_wired_feature2 from "../../static/images/gps/gpsWired_feature2.svg";
import gps_wired_feature3 from "../../static/images/gps/gpsWired_feature3.svg";
import gps_wired_feature4 from "../../static/images/gps/gpsWired_feature4.svg";
import gps_wireless_feature2 from "../../static/images/gps/gpsWireless_feature2.svg";
import gps_wireless_feature3 from "../../static/images/gps/gpsWireless_feature3.svg";

const FEATURES_WIRED = [
	{
		id: 1,
		img: gps_wired_feature1,
		title: "Xem vị trí xe hiện tại",
	},
	{
		id: 2,
		img: gps_wired_feature2,
		title: "Xem lộ trình / số km xe đã di chuyển",
	},
	{
		id: 3,
		img: gps_wired_feature3,
		title: "Xem vận tốc ",
	},
	{
		id: 4,
		img: gps_wired_feature4,
		title: "Xem lịch sử hành trình từng chuyến di",
	},
];

const FEATURES_WIRELESS = [
	{
		id: 1,
		img: gps_wired_feature1,
		title: "Xem vị trí xe hiện tại",
	},
	{
		id: 2,
		img: gps_wireless_feature2,
		title: "Sạc pin nhanh chóng, thời lượng lâu",
	},
	{
		id: 3,
		img: gps_wireless_feature3,
		title: "Xem dung lượng dễ dàng & cảnh báo khi cần sạc",
	},
];

const TYPE_INSTALL_WIRED = [
	{
		id: 1,
		icon: <Setting />,
		title: "Garage xe",
		desc: "Chủ xe có thể mang xe và thiết bị đến các garage ô tô để kĩ thuật viên tại garage lắp đặt",
	},
	{
		id: 2,
		icon: <Home />,
		title: "Tự lắp đặt tại nhà",
		desc: `Các chủ xe có kiến thức và kinh nghiệm cơ bản về kĩ thuật ô tô có thể tham khảo video hướng dẫn đặt GPS <a href="https://www.youtube.com/watch?v=UnMp5cVBxjY&ab_channel=Mioto" target="_blank" class="link"> tại đây </a>`,
	},
];

const TYPE_INSTALL_WIRELESS = [
	{
		id: 1,
		icon: <Setting />,
		title: "Vị trí lắp đặt",
		desc: "Đảm bảo vị trí có độ an toàn về độ ẩm và nhiệt độ cho thiết bị. Đảm bảo thiết bị được cố định chắc chắn như kẹp, dây buộc...",
	},
	{
		id: 2,
		icon: <Home />,
		title: "Tự lắp đặt tại nhà",
		desc: "Dễ thao tác tháo lắp không cần đấu nối trực tiếp nguồn, phù hợp trên tất cả các dòng xe hiện nay.",
	},
];

const OTHER_INFO = [
	{
		id: 1,
		icon: <Secure />,
		title: "Bảo hành",
		desc: "12 tháng (đổi mới thiết bị nếu bị lỗi phần cứng)",
	},
	{
		id: 2,
		icon: <Truck />,
		title: "Thời gian giao hàng",
		desc: "3-5 ngày sau khi đặt hàng",
	},
	{
		id: 3,
		icon: <Card />,
		title: "Hình thức thanh toán",
		desc: "Chuyển khoản qua tài khoản ngân hàng của Mioto",
	},
];

const LINK = "https://docs.google.com/forms/d/e/1FAIpQLSdi_HUexc0_Q2BY-KbnCB1L7fewj9QGle7P9gH2RepQlFxiTw/viewform";

const SwiperFeatures = ({ features }) => {
	return (
		<Swiper
			className="swiper-intro-register"
			slidesPerView={1}
			spaceBetween={15}
			modules={[Pagination]}
			pagination={{
				el: ".swiper-pagination",
				clickable: true,
				dynamicBullets: true,
			}}
			breakpoints={{
				1200: {
					slidesPerView: 3,
					spaceBetween: 15,
				},
				992: {
					slidesPerView: 2.5,
					spaceBetween: 15,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 15,
				},
				577: {
					slidesPerView: 1.5,
					spaceBetween: 15,
				},
			}}>
			{features.map((ft) => (
				<SwiperSlide key={ft.id}>
					<div className="green-card-option">
						<div className="horizontal-content">
							<div className="horizontal-content--img">
								<img loading="lazy" src={ft.img} />
							</div>
							<div className="horizontal-content--content">
								<h5>{ft.title}</h5>
							</div>
						</div>
					</div>
				</SwiperSlide>
			))}
			<div className="swiper-pagination swiper-pagination--green" />
		</Swiper>
	);
};

const SwiperTypeInstall = ({ typeInstall }) => (
	<Swiper
		className="swiper-type-install list-type-install"
		slidesPerView={1.5}
		spaceBetween={15}
		modules={[Pagination]}
		pagination={{
			el: ".swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		}}
		breakpoints={{
			768: {
				slidesPerView: 2,
				spaceBetween: 15,
			},
			577: {
				slidesPerView: 1.5,
				spaceBetween: 15,
			},
		}}>
		{typeInstall.map((ti) => (
			<SwiperSlide key={ti.id}>
				<div className="type-item green-card-option">
					<div className="number">{ti.id}.</div>
					<div className="wrap-svg">{ti.icon}</div>
					<h6>{ti.title}</h6>
					<p dangerouslySetInnerHTML={{ __html: ti.desc }} />
				</div>
			</SwiperSlide>
		))}
		<div className="swiper-pagination" />
	</Swiper>
);

const SwiperOtherInfo = () => (
	<Swiper
		className="list-other-info swiper-other-info"
		slidesPerView={1.5}
		spaceBetween={15}
		modules={[Pagination]}
		pagination={{
			el: ".swiper-pagination",
			clickable: true,
			dynamicBullets: true,
		}}
		breakpoints={{
			768: {
				slidesPerView: 3,
				spaceBetween: 15,
			},
			577: {
				slidesPerView: 1.5,
				spaceBetween: 15,
			},
		}}>
		{OTHER_INFO.map((oi) => (
			<SwiperSlide key={oi.id}>
				<div className="other-info-item green-card-option">
					<div className="number">{oi.id}.</div>
					<div className="wrap-svg">{oi.icon}</div>
					<h6>{oi.title}</h6>
					<p>{oi.desc}</p>
				</div>
			</SwiperSlide>
		))}
		<div className="swiper-pagination" />
	</Swiper>
);

const GPSRegister = () => {
	useEffect(() => {
		window.scrollTo(0, 0);
	}, []);

	return (
		<div className="mioto-layout">
			<Header notLineHeader={true} />
			<section className="body">
				<div className="gps-page">
					<div className="banner-top-sect">
						<div className="m-container">
							<div
								className="background space sec"
								style={{
									backgroundImage: `url(${bg_top})`,
								}}
							/>
							<div className="content-container">
								<img loading="lazy" className="bg-content" src={bg_content} />
								<div className="main-content">
									<h1>
										<div className="text-success">MITRACK 4G</div>Giúp Chủ Xe Dễ Dàng Kiểm Tra Vị Trí Xe 24/7
									</h1>
									<a className="btn btn--s btn-black" href={LINK} target={`_blank`}>
										Đăng ký ngay
									</a>
								</div>
							</div>
						</div>
					</div>
					<div className="gps-page__intro space sec">
						<div className="m-container">
							<div className="main-content">
								<h2>Giới thiệu về MITRACK 4G</h2>
								<p>
									MITRACK 4G với thiết kế nhỏ gọn (kích thước 7.3cm x 3cm x 1cm), chịu được nhiệt độ môi trường cao với
									công nghệ chip GPS tiên tiến giúp chủ xe dễ dàng kiểm tra vị trí xe 24/7.
								</p>
								<p>
									Thiết bị cho vị trí có độ chính xác cao kèm lộ trình chi tiết giúp chủ xe có thể theo dõi từ xa vị trí
									của xe bằng điện thoại hoặc máy tính có kết nối internet.
								</p>
								<p>
									Đặc biệt, các đối tác chủ xe của Mioto có thể xem và kiểm tra vị trí xe ngay trên ứng dụng Mioto (tại
									phần <strong>Xe của tôi -{">"} GPS)</strong>.
								</p>
							</div>
							<div className="gps-img">
								<img loading="lazy" src={gps_wired} />
							</div>
						</div>
					</div>
					<div className="gps-feature space sec">
						<div className="m-container">
							<h2>Tính năng thiết bị</h2>
							<SwiperFeatures features={FEATURES_WIRED} />
						</div>
					</div>
					<div className="gps-price-list space sec">
						<div className="m-container">
							<h2>Bảng giá dịch vụ</h2>
							<div className="gps-price-list__table">
								<div className="table-wrap">
									<div className="box-content__first"> </div>
									<div className="box-content">
										<h6>Nguyên giá</h6>
									</div>
									<div className="box-content">
										<h6>Giá ưu đãi</h6>
									</div>
								</div>
								<div className="table-wrap">
									<div className="box-content__first">
										<p>Giá thiết bị MITRACK 4G</p>
									</div>
									<div className="box-content">
										<p>1.800.000</p>
									</div>
									<div className="box-content">
										<p>500.000</p>
									</div>
								</div>
								<div className="table-wrap">
									<div className="box-content__first">
										<p>Phí duy trì(*)</p>
									</div>
									<div className="box-content">
										<p>900.000</p>
									</div>
									<div className="box-content">
										<p>600.000</p>
									</div>
								</div>
								<div className="table-wrap">
									<div className="box-content__first">
										<p>Tổng</p>
									</div>
									<div className="box-content">
										<p className="total">2.700.000 đ</p>
									</div>
									<div className="box-content">
										<p className="total">1.100.000 đ</p>
									</div>
								</div>
							</div>
							<div className="gps-price-list__note">
								* Tiết kiệm <strong>1.600.000đ </strong>
								chương trình ưu đãi dành riêng cho các đối tác chủ xe MIOTO
							</div>
							<div className="line" />
							<div className="gps-price-list__sumary">
								<div className="gps-price--title">
									<p>Phí 4G + Phí phần mềm</p>
									{/* <p className="note">(Miễn phí 6 tháng đầu tiên)</p> */}
								</div>
								<div className="gps-price">
									<p className="gps-price--item blue">600.000d / 12 tháng</p>
								</div>
							</div>
						</div>
					</div>
					<div className="gps-install space sec">
						<div className="m-container">
							<h2>Hướng dẫn đặt hàng</h2>
							<p className="subtitle">
								Để đăng kí đặt hàng, Quý đối tác vui lòng bấm vào đường link{" "}
								<a href={LINK} target={`_blank`} className="text-success">
									đăng ký{" "}
								</a>
								và để lại thông tin đặt hàng. Nhân viên Mioto sẽ chủ động liên hệ Quý đối tác để tư vấn và xác nhận đơn
								hàng. Thời gian giao hàng dự kiến từ 3 - 5 ngày sau khi xác nhận đặt hàng.
							</p>
						</div>
					</div>
					<div className="gps-install space sec">
						<div className="m-container">
							<h2>Hình thức lắp đặt</h2>
							<SwiperTypeInstall typeInstall={TYPE_INSTALL_WIRED} />
						</div>
					</div>
					<div className="gps-install space sec">
						<div className="m-container">
							<h2>Thông tin khác</h2>
							<SwiperOtherInfo />
						</div>
					</div>
					<div className="banner-bottom">
						<img loading="lazy" src={bg_bottom} />
						<div className="main-content">
							<h2>Đăng ký MITRACK 4G trên MIOTO</h2>
							<p>
								MITRACK 4G với thiết kế nhỏ gọn, cho vị trí có độ chính xác cao. Các đối tác chủ xe Mioto có thể theo
								dõi vị trí và quản lý xe ngay trên ứng dụng.
							</p>
							<a href={LINK} target={`_blank`} className="btn btn--m btn-primary">
								Đăng ký ngay
							</a>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</div>
	);
};

export default GPSRegister;
